// extracted by mini-css-extract-plugin
module.exports = {"chip":"TableChip_chip__1GpKp","blue":"TableChip_blue__275V-","green":"TableChip_green__3gWln","red":"TableChip_red__3CS4X"};